export default __webpack_public_path__ + "static/media/electric.bc35c5a3.svg";